export enum TextBadgeDesign{
  Error = "Error",
  Info = "Info",
  Success = "Success",
  Warning = "Warning",
  Neutral = "Neutral",
}

export enum NumberBadgeDesign{
  Blue = "Blue",
  Red = "Red",
  White = "White",
  Neutral = "Neutral",
}

export const textBadgeOptions = [TextBadgeDesign.Error, TextBadgeDesign.Info, TextBadgeDesign.Neutral, TextBadgeDesign.Success, TextBadgeDesign.Warning];
export const numberBadgeOptions = [NumberBadgeDesign.Blue, NumberBadgeDesign.Red, NumberBadgeDesign.White, NumberBadgeDesign.Neutral];
